<template>
  <div class="card">
    <div class="bg-blue-light p-1">
      <TitleButton
          :showBtn="false"
          :showAddNew="false"
          title="Leave Balance Process"
      />
    </div>

    <div class="row p-2">
      <div class="col-12 col-sm-6 col-md-4 col-lg-3">
        <label class="col-form-label">Leave Policy</label>
        <v-select
            placeholder="Select Leave Policy"
            v-model="leavePolicyId"
            :options="leavePolicy"
            label="name"
            :reduce="name => name.id"
        />
      </div>
      <div class="col-12 col-sm-6 col-md-3 col-lg-2">
        <label class="col-form-label">Date From</label>
        <input type="date" class="form-control" v-model="dateFrom">
      </div>
      <div class="col-12 col-sm-6 col-md-3 col-lg-2">
        <label class="col-form-label">Date To</label>
        <input type="date" class="form-control" v-model="dateTo">
      </div>
      <div class="col-12 col-sm-6 col-md-3 col-lg-2">
        <label class="col-form-label">Number of Days</label>
        <input type="number" min="0" class="form-control" v-model="numberOfDays">
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-lg-2 mt-auto">
        <button :disabled="processing" @click="onClickProcess" class="btn btn-primary waves-effect waves-float waves-light">
          Process
        </button>
      </div>
    </div>

    <div class="col-12 px-2 mt-2 mb-4">
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead>
          <tr>
            <th class="text-center">Leave Policy</th>
            <th class="text-center">Start Date</th>
            <th class="text-center">End Date</th>
            <th class="text-center">Status</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, i) in tableItems" :key="i">
            <td class="text-center">{{ item.leave_policy_name }}</td>
            <td class="text-center">{{ item.start_date }}</td>
            <td class="text-center">{{ item.end_date }}</td>
            <td class="text-center text-capitalize">{{ item.status }}</td>
          </tr>
          </tbody>
        </table>
        <p v-if="tableItems.length < 1" class="text-center mt-5">No data</p>
      </div>
    </div>

    <div class="px-2 position-absolute bottom-0 mt-4">
      <Pagination :offset="params.offset" @onPageChange="onPageChange" ref="pagination"/>
    </div>

    <GlobalLoader/>
  </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton.vue'
import GlobalLoader from '@/components/atom/GlobalLoader.vue'
import Pagination from '@/components/atom/Pagination'
import {inject, onMounted, ref} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import {useStore} from 'vuex'
import handleHrPayroll from '@/services/modules/hrPayroll/hrPayroll'

const route = useRoute()
const router = useRouter()
const store = useStore()
const showError = inject('showError')
const showSuccess = inject('showSuccess')

const {fetchLeavePolicyList, processLeaveBalance, fetchProcessTrackerData} = handleHrPayroll()

const leavePolicy = ref([])
const leavePolicyId = ref(null)
const dateFrom = ref('')
const dateTo = ref('')
const numberOfDays = ref('')
const processing = ref(false)
const tableItems = ref([])
const params = ref({
  offset: 20
})

const getQuery = () => {
  return `?company_id=${route.params.companyId}`
}

const getLeavePolicy = () => {
  const query = getQuery() + '&is_all=true&status=active'
  fetchLeavePolicyList(query).then((res) => {
    if (!res.status) return
    leavePolicy.value = res.data
  })
}

const setPagination = (data) => {
  store.commit('setPaginationData', {
    records: data.total,
    perPage: data.per_page,
    currentPage: data.current_page
  })
}

const getProcessList = () => {
  let query = getQuery() + '&type=leave_balance'
  if (route.query.page) query += '&page=' + route.query.page
  query += '&offset=' + params.value.offset
  tableItems.value = []
  fetchProcessTrackerData(query).then((res) => {
    if (!res.status) {
      store.commit('resetPagination')
      return
    }
    tableItems.value = res.data.data
    setPagination(res.data)
  })
}

const onPageChange = async (page) => {
  const routeQuery = Object.assign({}, route.query)
  routeQuery.page = page
  await router.push({path: route.path, query: routeQuery})
  getProcessList()
}

const onClickProcess = () => {
  if (!leavePolicyId.value) return showError('Please select leave policy')
  if (!dateFrom.value) return showError('Please select date from')
  if (!dateTo.value) return showError('Please select date to')
  if (numberOfDays.value === '') return showError('Please enter number of days')

  const data = {
    company_id: route.params.companyId,
    leave_policy_id: leavePolicyId.value,
    number_of_days: numberOfDays.value,
    date_from: dateFrom.value,
    date_to: dateTo.value
  }

  processing.value = true
  processLeaveBalance(data).then((res) => {
    if (!res.status) return showError(res.message)
    showSuccess(res.message)
    getProcessList()
  }).finally(() => {
    processing.value = false
  })
}

onMounted(() => {
  getLeavePolicy()
  getProcessList()
})
</script>
